// Shared constants (TTS/STS defaults, timeline raster, session limits).

export const TIMELINE_GRID_STEP = 0.1; // seconds — chip snap raster

export const RECORDING_SESSION_TAKE_LIMIT = 10;

export const DEFAULT_ASSET_DURATION = 30;  // fallback when no video + no admin targetDuration
export const MAX_ASSET_DURATION = 180;

export const VIDEO_EXPORT_STREAM_THRESHOLD = 500 * 1024 * 1024; // 500MB

export const VIDEO_DUCKING_DEFAULT_STRENGTH = 50; // percent reduction

/** Auto-Duck ramp times. Block-edge driven — pauses within a block stay
 *  ducked, release only fires when voice playback actually stops.
 *  Attack short so dialogue cuts in cleanly; release ~300ms so the bed
 *  comes back without a hard cut after each block. */
export const VIDEO_DUCKING_ATTACK_MS = 2;
export const VIDEO_DUCKING_RELEASE_MS = 300;

export const TTS_PARAMS_V2_DEFAULT = {
  stability: 0.5,
  similarity: 0.75,
  style: 0.0,
  speakerBoost: true,
} as const;

export const TTS_PARAMS_V4_DEFAULT = {
  stability: 0.5,
  similarity: 0.75,
};

/** Hard cap on takes per TTS block. Mirrored as the chip-row's "X / 5"
 *  count and enforced in the session store on take append. */
export const MAX_TAKES_PER_BLOCK = 5;

export const STS_PARAMS_DEFAULT = {
  stability: 0.5,
  similarity: 0.5,
  style: 0.15,
  speakerBoost: true,
  removeNoise: false,
} as const;

export const OFFLINE_RENDER_SAMPLE_RATE = 48000;
export const OFFLINE_RENDER_CHANNELS = 2;

// KV-Präfixe und TTLs liegen im Dienst (`server/kv.ts`), nicht hier.
